import React from 'react';
import { RelatedTag } from '../tags';
import { When } from 'react-if';
import { OrganizationTypeId, SonarObjectType } from '@sonar-software/sonar-ts-types';

export interface SonarRecordRelationshipsProps {
	relatedOrgs?: Array<OrganizationTypeId>;
	relatedField?: string;
	source?: string;
}

export const SonarRecordRelationships: React.FC<SonarRecordRelationshipsProps> = ({
	relatedField,
	relatedOrgs,
	source
}) =>
	<>
		<When condition={ source }>
			<RelatedTag
				displayName={ source as string }
				sonarObjectType={ SonarObjectType.PardotField } />
		</When>
		<When condition={ relatedField }>
			<RelatedTag
				displayName={ relatedField as string }
				sonarObjectType={ SonarObjectType.SalesforceField } />
		</When>
		{ relatedOrgs?.map((orgTypeId) =>
			<RelatedTag
				displayName={ OrganizationTypeId[ orgTypeId ] }
				key={ orgTypeId } />) }
	</>;

